// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__8zOR+"};